export default __webpack_public_path__ + "static/media/icon-third-house.58c9dbdf.svg";